import React from "react";
import PropTypes from "prop-types";
import {Button, Col, ControlLabel, FormGroup, Row} from "react-bootstrap";
import MovementOrderService from "./MovementOrderService";
import Notify from "../services/Notify";
import Loading from "../component/Loading/Loading";
import Box from "../component/Box/Box";

class BizTransactionForm extends React.Component {

  service = new MovementOrderService();

  constructor(props) {
    super(props);
    this.state = {entity: {}};
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      this.setState({loading: true});
      this.service.findById(id).then(
          data => this.setState(
              {
                loading: false,
                entity: data
              }),
          error => {
            const state = {loading: false};
            if (error.response.status === 404) {
              state.message = 'Entidade não encontrada!';
            } else {
              state.message = 'Erro inesperado!';
              Notify.error('Falha o buscar entidade!', error)
            }
            this.setState(state);
          }
      )
    }
  }

  submitForm() {
    const {entity} = this.state;
    const entityToSave = {
      id: entity.id,
      bizLocId: this.bizLocId.value,
      filterDate: new Date(this.filterDate.value).toISOString(),
      bizTransId: this.bizTransId.value,
      requestedBy: this.requestedBy.value,
      approvedBy: this.approvedBy.value,
      locDestId: this.locDestId.value,
      locDestName: this.locDestName.value,
      cfopCode: this.cfopCode.value,
      status: this.status.value,
      expiration: new Date(this.expiration.value).toISOString(),
      bizTransDate: new Date(this.bizTransDate.value).toISOString(),
      version: entity.version
    };

    this.service.save(entityToSave).then(
        () => {
          this.props.history.goBack();
          Notify.success('Entidade salva');
        },
        (error) =>
            Notify.error('Falha ao salvar entidade:', error)
    );
  }

  render() {
    const {loading, entity = {}, message} = this.state;
    if (loading) {
      return <Loading/>
    }
    if (message) {
      return <h2>{message}</h2>
    }
    return (
        <Box info>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm();
          }}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>Código</ControlLabel>
                  <input type="text" className="form-control" ref={name => (this.orderCode = name)} defaultValue={entity && entity.orderCode}/>
                </FormGroup>
              </Col>
            </Row>

            <div className="pull-right">
              <Button onClick={() => this.props.history.goBack()}>Cancelar</Button>
              <Button type="submit" bsStyle="success">Salvar</Button>
            </div>

          </form>
        </Box>);
  }
}

BizTransactionForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default BizTransactionForm;


// WEBPACK FOOTER //
// ./src/movementOrder/MovementOrderForm.js